module.exports = __webpack_public_path__ + "img/copper13.74324202.gif";